import { put, call, take, fork } from 'redux-saga/effects'
import { teamsListService } from '../../api/teams'
import { teamListSuccess } from '../../reducers/teams/action'
import { TEAM_LIST } from '../../reducers/teams/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* teamsListFlow(payload) {
  try {
    const { callback } = payload

    const response = yield call(teamsListService)

    callback(response)
    yield put(teamListSuccess(response.data))

    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* teamsListWatcher() {
  while (true) {
    const action = yield take(TEAM_LIST)
    const { payload } = action

    yield fork(generalSaga, teamsListFlow, payload)
  }
}
